import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import LandingPage from './LandingPage';
import IndirPage from './IndirPage';
import Dashboard from './Dashboard';
import ProtectedRoute from './ProtectedRoute';
import CheckInScanPage from './CheckInScanPage';
import PersonnelSignupPage from './PersonnelSignupPage';
import BaristaProtectedRoute from './BaristaProtectedRoute';
import BaristaHomePage from './BaristaHomePage';
import StaffChecklistPage from './StaffChecklistPage';
function App() {
  return (
    <BrowserRouter>
      <Analytics />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/indir" element={<IndirPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/personnel-signup" element={<PersonnelSignupPage />} />
        <Route path="/check-in" element={<CheckInScanPage />} />
        <Route
          path="/barista"
          element={
            <BaristaProtectedRoute>
              <BaristaHomePage />
            </BaristaProtectedRoute>
          }
        />
        <Route
          path="/barista/checklist"
          element={
            <BaristaProtectedRoute>
              <StaffChecklistPage />
            </BaristaProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ekip"
          element={
            <ProtectedRoute>
              <Navigate to="/dashboard?section=ekip" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/waste"
          element={
            <ProtectedRoute>
              <Navigate to="/dashboard" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ads"
          element={
            <ProtectedRoute>
              <Navigate to="/dashboard?section=ads" replace />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
